// MUI twin of design/ui.tsx ProgressBar. 6px track + tone-colored fill. Prop
// API matches the kt original verbatim (SpineTone renamed to the local union
// per the brief — "red" | "green" | "teal").
import { Box } from "@mui/material";
import { brainTokens } from "../design/brainTheme";

const c = brainTokens.color;

const FILL: Record<"red" | "green" | "teal", string> = {
  red: c.dangerText,
  green: c.successDot,
  teal: c.teal,
};

export function ProgressBar({
  value,
  tone = "teal",
}: {
  value: number;
  tone?: "red" | "green" | "teal";
}) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <Box
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      sx={{ height: "6px", borderRadius: "999px", background: c.borderLight2, overflow: "hidden" }}
    >
      <Box sx={{ height: "100%", width: `${pct}%`, borderRadius: "999px", background: FILL[tone], transition: "width .15s ease" }} />
    </Box>
  );
}
